import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { STAGES, featuredPath, subcategoryPath } from './navData';
import './TypeMenu.css';

// Desktop flyout for a category: left column = type name + stage list, right
// panel = featured names for the hovered stage. Clicking a stage browses it;
// clicking a name searches for it. (Mobile uses MobileMenu.)
// placement "rail" pins it beside the homepage side rail; "header" drops it
// below the header's icon row.
const TypeMenu = ({ type, onClose, onMouseEnter, onMouseLeave, height, placement = 'rail' }) => {
    const navigate = useNavigate();
    // Each type can define its own subcategory list (e.g. Trainers), otherwise
    // fall back to the Pokémon stages (Stage 2 / Stage 1 / Basic).
    const stages = type.stageList || STAGES;
    const [stageId, setStageId] = useState(stages[0].id);

    // Reset to the first subcategory whenever the type changes.
    useEffect(() => { setStageId(stages[0].id); }, [type.id]); // eslint-disable-line react-hooks/exhaustive-deps

    const featured = type.stages[stageId] || [];
    const stageLabel = stages.find((s) => s.id === stageId)?.label || '';

    const go = (path) => {
        if (!path) return;
        onClose();
        navigate(path);
    };

    return (
        <div
            className={`gh-typemenu${placement === 'header' ? ' gh-typemenu-header' : ''}`}
            role="menu"
            aria-label={`${type.label} type menu`}
            style={height ? { height } : undefined}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div className="gh-typemenu-left">
                <div className="gh-typemenu-titlerow">
                    <h3 className="gh-typemenu-title">{type.label}</h3>
                </div>
                <div className="gh-typemenu-stages">
                {stages.map((s) => (
                    <button
                        key={s.id}
                        type="button"
                        className={`gh-typemenu-stage ${stageId === s.id ? 'active' : ''}`}
                        onClick={() => go(subcategoryPath(type, s))}
                        onMouseEnter={() => setStageId(s.id)}
                    >
                        {s.label}
                        <span className="gh-typemenu-chev">›</span>
                    </button>
                ))}
                </div>
            </div>

            <div className="gh-typemenu-right">
                <div className="gh-typemenu-headrow">
                    <h3 className="gh-typemenu-heading">Featured</h3>
                </div>
                {featured.length === 0 ? (
                    <p className="gh-typemenu-empty">No featured {stageLabel} {type.label} yet.</p>
                ) : (
                    <ul className="gh-typemenu-links">
                        {featured.map((name) => (
                            <li key={name}>
                                <button type="button" onClick={() => go(featuredPath(type, name))}>
                                    {name}
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default TypeMenu;
